module.exports = __webpack_public_path__ + "static/media/no_recent_Search.86fbc72a.svg";